// 客户信息管理
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">客户信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="100px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="realname" label="姓名：">
                                <el-input v-model="query.realname" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="mobile" label="手机：">
                                <el-input v-model="query.mobile" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="company" label="公司简称：">
                                <el-input v-model="query.company" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="type" label="类别：">
                                <el-select v-model="query.type" placeholder="请选择">
                                    <el-option v-for="item in typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-right:200px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>
                        <el-button type="primary" @click="insertCustomerInfo" size="small">新增</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-table :data="orderInfoList" border stripe
                            @selection-change="selectionLineChangeHandle" ref="refTable" height='600px'
                            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="userName" label="账号" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" min-width="100" prop="realname" label="姓名"></el-table-column>
                            <el-table-column align="center" min-width="150" prop="company" label="公司简称"></el-table-column>
                            <el-table-column align="center" min-width="120" prop="mobile" label="联系方式"></el-table-column>
                            <el-table-column align="center" min-width="60" prop="place" label="地区"></el-table-column>
                            <el-table-column align="center" min-width="60" prop="type" label="分类"></el-table-column>
                            <el-table-column align="center" min-width="60" prop="attribute1" label="登录次数"></el-table-column>
                            <el-table-column align="center" min-width="200" prop="attribute2" label="UUID"></el-table-column>
                            <el-table-column align="center" min-width="80" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectCustomerList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div class="text e-info auto-table">
            <el-dialog title="修改信息" :visible.sync = "dialogTableVisible10" @close="closeSava" 
                center :close-on-click-modal="false" width="400px">
                <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" 
                        class="demo-form-inline" ref="addDataForm" :rules="rules">
                    <el-form-item prop="userName" label="账号：">
                        <el-input style="width:180px;" v-model="addDataForm.userName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="realname" label="姓名：">
                        <el-input style="width:180px;" v-model="addDataForm.realname" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="company" label="公司简称：">
                        <el-input style="width:180px;" v-model="addDataForm.company" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="place" label="地区：">
                        <el-input style="width:180px;" v-model="addDataForm.place" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="mobile" label="联系方式：">
                        <el-input style="width:180px;" v-model="addDataForm.mobile" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="type" label="分类：">
                        <el-input style="width:180px;" v-model="addDataForm.type" placeholder="请输入"></el-input>
                    </el-form-item>
                    <!--
                    <el-form-item prop="remark" label="备注：">
                        <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item><br>-->
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeSava">取 消</el-button>
                    <el-button type="primary" @click="savaCustomerInfo">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import util from '../common/js/util';
    export default {
        data() {
            return {
                isAble: true,
                dialogTableVisible10: false,
                typeList: [{'value':'一级'},{'value':'二级'},{'value':'三级'}],
                placeList: [{'value':'全部'},{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                isq: '',
                inv_status: '',
                addDataForm: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                orderInfoList: [],
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                caozuo: '新增',
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 50,
                    total: 0
                },
                rules:{
                    userName:[
                        {
                            required:true,
                            message:'请输入',
                            trigger:'blur'
                        }
                    ],
                    realname:[
                        {
                            required:true,
                            message:'请输入',
                            trigger:'blur'
                        }
                    ]
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement("input");
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand("Copy");
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单数据
            savaCustomerInfo() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaCustomerInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            id: _this.addDataForm.id,
                            userName: _this.addDataForm.userName,
                            realname: _this.addDataForm.realname,
                            company: _this.addDataForm.company,
                            place: _this.addDataForm.place,
                            mobile: _this.addDataForm.mobile,
                            type: _this.addDataForm.type,
                            caozuo: _this.caozuo
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                                _this.dialogTableVisible10 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js')
                    const tHeader = ['姓名','公司','联系方式', '地区', '数据日期']
                    const filterVal = ['name','company','iphone', 'place', 'data_date']
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '会员信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../common/js/Export2Excel.js')
                    const tHeader = ['姓名','公司','联系方式', '地区', '数据日期']
                    const filterVal = ['name','company','iphone', 'place', 'data_date']
                    const list = this.orderInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '会员信息')
                })
            },
            // 加载订单信息分页列表
            selectList() {
                let _this = this;
                util.publicget('/order/queryCustomerInfoListPageModel', {
                    realname: _this.query.realname,
                    mobile: _this.query.mobile,
                    company: _this.query.company,
                    type: _this.query.type,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.orderInfoList = res.obj;
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // dialog 关闭，数据清空
            closeSava() {
                this.selectList();
            },
            // 加载查询订单单条记录
            selectCustomerList(rows) {
                let _this = this;
                util.publicget('/order/queryCustomerInfoList', {
                    equalsId: rows.id
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                            _this.caozuo = '修改';
                        }else {
                            _this.showMsg("数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 新增客户
            insertCustomerInfo() {
                let _this = this;
                _this.addDataForm = [];
                _this.dialogTableVisible10 = true;
                _this.caozuo = '新增';
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/customerInfoList.vue